export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/util/eventConsts.js
// module id = 1042
// module chunks = 0